import React from 'react';
import { createSvgIcon } from '../../utils/createSvgIcon';

export const InventoryIcon = createSvgIcon(
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M11.3612 4.33536L5 8.00801V15.3533L11.3612 19.026L17.7224 15.3533V8.00801L11.3612 4.33536ZM18.7224 7.43066L11.3612 3.18066L4 7.43066V15.9307L11.3612 20.1807L18.7224 15.9307V7.43066Z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M11.3612 12.258L18.3435 8.22676L17.8435 7.36073L11.3612 11.1033L4.90382 7.37515L4.40382 8.24118L11.3612 12.258Z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M11.3612 14.8733L18.3435 10.842L17.8435 9.976L11.3612 13.7186L4.90382 9.99042L4.40382 10.8564L11.3612 14.8733Z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M9.00002 16.18L7.00002 14.9337V13.68L9.00002 14.9337V16.18Z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M10.8611 11.6809L10.8611 19.2001H11.8611L11.8611 11.6809L10.8611 11.6809Z"
      fill="currentColor"
    />
  </svg>,
  'InventoryIcon'
);
